import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import LoginIcon from '@mui/icons-material/Login';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import { HeaderNoLog } from '../components/HeaderNoLog';

import Swal from 'sweetalert2';
import { login } from '../services/apis';
import { APP_DATA } from '../data';
// import { Header } from '../componenets/Header';
// import { CabeceraTitulo } from '../componenets/CabeceraTitulo';



export const Login = ({ username, setUsername, password, setPassword }) => {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();


    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleLogin();
        }
    };
    const handleLogin = async () => {
        try {

            const data = await login({ usuario: username, password });



            if (data.user) {
                Swal.fire({
                    icon: "success",
                    title: `Bienvenido/a \n${data.user.nombreUsuario}`,
                    showConfirmButton: false,
                    timer: 1500
                });
                navigate('/');
                // window.history.back();
            }
        } catch (error) {

            Swal.fire({

                icon: "error",
                title: `Error de inicio de sesión: \n${error.response?.data?.message || "Error al iniciar sesion"}`,
                showConfirmButton: false,
                timer: 1500
            });
            console.error('Error de red:', error.message);
        }
    };




    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Grid
            container
            direction="column"
            size={{ xs: 12 }}
            sx={{
                justifyContent: "start",
                alignItems: "center",
                minHeight: '90vh',
            }}
        >
            <HeaderNoLog></HeaderNoLog>


            <Grid
                container
                direction="column"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: { xs: '6em', md: '10em' },
                    marginBottom: '1em'
                }}
                className='fade-in'

            >

                <Grid
                    container
                    direction="column"
                    size={{ xs: 11, sm: 8, md: 6, xl: 3.5 }}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        bgcolor: 'white',
                        borderRadius: '8px',
                        border: '1px solid #dadada',
                    }}
                    spacing={2}
                    className='card-main'
                >
                    <Grid
                        container
                        direction="column"
                        size={{ xs: 11, sm: 10 }}
                        sx={{
                            justifyContent: "center",
                            alignItems: "start",
                            mt: '2em',
                        }}
                        spacing={0}
                    >

                        {/* <PersonIcon sx={{ fontSize: 80 }} color='negro' /> */}

                        <Typography variant='h4'>
                            Iniciar sesión
                        </Typography>

                        <Typography variant='caption'>
                            Bienvenid@ a {APP_DATA.empresaNombre}
                        </Typography>
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        size={{ xs: 11, sm: 10 }}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <TextField id="outlined-basic" label="Usuario" variant="outlined" color='negro' style={{ minWidth: '100%' }} onChange={(e) => setUsername(e.target.value)} onKeyPress={handleKeyPress} />
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        size={{ xs: 11, sm: 10 }}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {/* <h2>Contraseña</h2> */}
                        <FormControl variant="outlined" style={{ minWidth: '100%' }} onKeyPress={handleKeyPress}>
                            <InputLabel htmlFor="outlined-adornment-password" color='negro' >Contraseña</InputLabel>
                            <OutlinedInput
                                color='cyan'
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Contraseña"
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </FormControl >
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        size={{ xs: 11, sm: 10 }}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            mb: '3em'
                        }}
                    >
                        <Button variant="contained" color='negro' style={{ minWidth: '100%' }} onClick={() => handleLogin()}>Iniciar sesion&nbsp;<LoginIcon fontSize='small' /></Button>
                    </Grid>


                </Grid>
            </Grid>
        </Grid>

    )
}
